import styles from './index.module.scss'

const InnerPageHeader = () => {
    return (
        <div className={`dark ${styles.bg}`}/>
    )
}

export default InnerPageHeader